// extracted by css-extract-rspack-plugin
export default {"dropdown":"Popover-module__dropdown___SHqDM"};